/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { ConstantNodeDependencies } from './dependenciesConstantNode.generated';
import { FunctionNodeDependencies } from './dependenciesFunctionNode.generated';
import { OperatorNodeDependencies } from './dependenciesOperatorNode.generated';
import { ParenthesisNodeDependencies } from './dependenciesParenthesisNode.generated';
import { SymbolNodeDependencies } from './dependenciesSymbolNode.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { divideDependencies } from './dependenciesDivide.generated';
import { equalDependencies } from './dependenciesEqual.generated';
import { isZeroDependencies } from './dependenciesIsZero.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { parseDependencies } from './dependenciesParse.generated';
import { powDependencies } from './dependenciesPow.generated';
import { simplifyDependencies } from './dependenciesSimplify.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createRationalize } from '../../factoriesAny.js';
export var rationalizeDependencies = {
  bignumberDependencies: bignumberDependencies,
  fractionDependencies: fractionDependencies,
  ConstantNodeDependencies: ConstantNodeDependencies,
  FunctionNodeDependencies: FunctionNodeDependencies,
  OperatorNodeDependencies: OperatorNodeDependencies,
  ParenthesisNodeDependencies: ParenthesisNodeDependencies,
  SymbolNodeDependencies: SymbolNodeDependencies,
  addDependencies: addDependencies,
  divideDependencies: divideDependencies,
  equalDependencies: equalDependencies,
  isZeroDependencies: isZeroDependencies,
  multiplyDependencies: multiplyDependencies,
  parseDependencies: parseDependencies,
  powDependencies: powDependencies,
  simplifyDependencies: simplifyDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createRationalize: createRationalize
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRationalize.generated.js
// module id = 1628
// module chunks = 0